<!--  -->
<template>
  <div class="modal-consult" v-show="show" @click.self="close">
    <div class="box">
      <div class="server">
        <img :src="currentSchool.serviceQrcode" />
        <div>长按二维码添加客服，咨询更多信息</div>
      </div>
    </div>
  </div>
</template>

<script>
import { reqUserList } from '@/api/index';

export default {
  components: {},
  props: {},
  data() {
    return {
      currentSchool: {},
      show: false,
    };
  },
  computed: {},
  watch: {},
  methods: {
    async getBranch() {
      const distributorId = localStorage.getItem('distributorId');
      const unionid = localStorage.getItem('unionid');
      const { data } = await reqUserList(unionid, distributorId);
      this.currentSchool = data?.[0];
      const { servicePhone, serviceQrcode } = this.currentSchool;
      if (!servicePhone && !serviceQrcode) {
        this.$emit('hideChat', false);
      } else {
        this.$emit('hideChat', true);
      }
    },
    handleCall() {
      //
    },
    close() {
      this.show = false;
    },
  },
  created() {
    this.getBranch();
  },
  mounted() {},
};
</script>
<style lang="scss" scoped>
.modal-consult {
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 200;
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  .box {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    min-height: 264px;
    max-height: 639px;
    padding: 60px 0;
    overflow-y: auto;
    background: #fff;
    border-radius: 36px 36px 0 0;
    .number {
      display: inline-block;
      width: 100%;
      padding-top: 80px;
      color: #0f87f2;
      font-weight: 400;
      font-size: 33px;
      line-height: 43px;
      text-align: center;
    }
    .server {
      img {
        display: block;
        width: 297px;
        height: 297px;
        margin: 0 auto;
        background: #000;
      }
      div {
        padding-top: 22px;
        color: #333;
        font-weight: 400;
        font-size: 29px;
        line-height: 43px;
        text-align: center;
      }
    }
  }
}
</style>
